import Vue from 'vue'
import App from './App.vue'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import {BootstrapVue} from 'bootstrap-vue';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
import {library} from '@fortawesome/fontawesome-svg-core';
import {
  faHandPaper,
  faHandRock,
  faHandScissors,
  faHandHoldingWater,
  faSkullCrossbones,
  faEdit,
  faCheck
} from '@fortawesome/free-solid-svg-icons';

library.add(faHandPaper, faHandRock, faHandScissors, faHandHoldingWater, faSkullCrossbones, faEdit, faCheck);

Vue.component('fa', FontAwesomeIcon);
Vue.use(BootstrapVue);
Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
